export interface PasswordValidationStatus {
  minLength: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
}

export interface PasswordRequirement {
  key: keyof PasswordValidationStatus;
  label: string;
  isValid: boolean;
}

export function getPasswordValidationStatus(password: string): PasswordValidationStatus {
  return {
    minLength: password.length >= 8,
    hasNumber: /\d/.test(password),
    hasSpecialChar: /[@#$%^&+=!]/.test(password),
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password)
  };
}

export function isPasswordValid(password: string): boolean {
  const status = getPasswordValidationStatus(password);
  return Object.values(status).every(Boolean);
}

export function getPasswordRequirements(password: string): PasswordRequirement[] {
  const status = getPasswordValidationStatus(password);
  return [
    { key: 'minLength', label: 'At least 8 characters', isValid: status.minLength },
    { key: 'hasNumber', label: 'Contains at least 1 number', isValid: status.hasNumber },
    { key: 'hasSpecialChar', label: 'Contains at least 1 special character', isValid: status.hasSpecialChar },
    { key: 'hasUppercase', label: 'Contains at least 1 uppercase letter', isValid: status.hasUppercase },
    { key: 'hasLowercase', label: 'Contains at least 1 lowercase letter', isValid: status.hasLowercase }
  ];
}
